/**
 * internal dependencies
 */
import { PIN_POOL_FORM } from "../forms/cardGroups/form-cardgroup-types";
import { usePinPool } from "../forms/cardGroups/pinPool/pin-pool-helpers";

/**
 * Function to control the warning modal in the Pin Pool form page.
 * 
 * @param {HTMLElement} warningPinPoolModal target id tag of the modal
 * @param {string} modalHeaderMSG header message
 * 
 * @returns void
 */
const WarningModalControl = (warningPinPoolModal: HTMLElement, modalHeaderMSG?: string) => {
  const { ppActive, ppActiveWarning, ppOptionalFields, ppFieldContainer } = PIN_POOL_FORM;
  const warningPinPoolModalclose = document.querySelector('#aafp_pin-pool-dismissed') as HTMLElement;
  const deletePinPoolContainer = document.querySelector('#aafp_pin-pool-delete') as HTMLElement;
  const modalHeader = document.querySelector('.modal_warning-subtitle') as HTMLElement;

  warningPinPoolModal.style.display = 'block';

  if ( modalHeaderMSG !== '' ) {
    modalHeader.innerText = modalHeaderMSG!;
  }
  
  warningPinPoolModalclose.onclick = function() {
    warningPinPoolModal.style.display = 'none';
    modalHeader.innerText = '';
    ppActive.checked = true;
    usePinPool(ppActive);
  }

  deletePinPoolContainer.onclick = function() {
    //ppActiveWarning.classList.add('aafp_display-none');
    warningPinPoolModal.style.display = 'none';
    modalHeader.innerText = '';
    // ppFieldContainer.innerHTML = '';
    // ppOptionalFields.forEach(field => {
    //   field.classList.add('aafp_pin-disabled');
    // });
    PIN_POOL_FORM.ppExport.setAttribute('disabled', 'true');
  };
}

export default WarningModalControl;